'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
export function Check({ checked, onChange, label, hint, disabled = false, name, ...aria }) {
    const id = useId();
    const hintId = `${id}-hint`;
    const describedBy = [aria['aria-describedby'], hint !== undefined ? hintId : undefined]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: "flex items-start gap-3", children: [_jsx(Checkbox, { id: id, name: name, checked: checked, disabled: disabled, "aria-invalid": aria['aria-invalid'], "aria-describedby": describedBy === '' ? undefined : describedBy, className: "mt-1", onCheckedChange: (value) => {
                    onChange(value === true);
                } }), _jsx(Label, { className: "cursor-pointer text-base font-normal", htmlFor: id, children: _jsxs("span", { className: "flex flex-col gap-1", children: [label, hint !== undefined ? (_jsx("span", { className: "text-muted-foreground text-sm", id: hintId, children: hint })) : null] }) })] }));
}
//# sourceMappingURL=Check.js.map